import React, { useEffect, useRef, useState } from "react";
import { useAsyncFn, useDebounce, useUpdateEffect } from "react-use";
import { SearchService } from "../apiService";
import Notify from "../../../../jquery/notify";

const SearchForm = ({ isPopupOpen, setResults }) => {
    const [value, setValue] = useState("");
    const [debouncedValue, setDebouncedValue] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const inputRef = useRef(null);

    const [, cancel] = useDebounce(
        () => {
            setDebouncedValue(value);
        },
        500,
        [value]
    );

    const [results, fetchResults] = useAsyncFn(
        async (query) => {
            try {
                const response = await SearchService.getResults(query);
                return response.data.data;
            } catch (error) {
                Notify.error(error);
            }
        },
        [debouncedValue]
    );

    useUpdateEffect(() => {
        if (debouncedValue.trim() === "") {
            setResults(null);
            return;
        }
        fetchResults(debouncedValue);
    }, [debouncedValue]);

    useUpdateEffect(() => {
        setResults(results.value);
    }, [results.value]);

    useEffect(() => {
        if (!isPopupOpen) return;

        setTimeout(() => {
            inputRef.current.focus();
        }, 100);
    }, [isPopupOpen, inputRef.current]);

    // console.log("SearchForm: Render!");

    return (
        <form action="#" className="search__form">
            <div
                className={[
                    "search__input",
                    isFocused ? "search__input--focus" : "",
                    value.length ? "search__input--filled" : "",
                ].join(" ")}
            >
                <div className="search__input__icon">
                    <svg className="icon">
                        <use xlinkHref="/images/sprite.svg#loop"></use>
                    </svg>
                </div>

                <div className="search__input__placeholder">Что ищем?</div>

                {results.loading ? (
                    <div className="search__input__loading"></div>
                ) : null}

                <input
                    ref={inputRef}
                    type="text"
                    className="search__input__self"
                    value={value}
                    onChange={(event) => {
                        setValue(event.target.value);
                    }}
                    onFocus={() => {
                        setIsFocused(true);
                    }}
                    onBlur={() => {
                        setIsFocused(false);
                    }}
                />
            </div>
            <div className="search__tips">
                Например,{" "}
                <a
                    href="#"
                    className="search__tips__item"
                    onClick={(event) => {
                        event.preventDefault();
                        setValue(event.target.innerText);
                    }}
                >
                    {window.searchExample}
                </a>
            </div>
        </form>
    );
};

export default SearchForm;
